// extracted by mini-css-extract-plugin
export default {"button":"ActionButton_button__x+8jh","approve":"ActionButton_approve__GAW4E","disapprove":"ActionButton_disapprove__Ymobn","revoke":"ActionButton_revoke__kfcr0"};